import React from 'react';
import { FadeIn } from './FadeIn';
import { Brain } from 'lucide-react';
export function PainSection() {
  return <section className="py-14 px-4 md:px-6 relative border-t border-slate-800/50 bg-[#0d1326]" data-id="element-127">
      <div className="max-w-4xl mx-auto text-center" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="w-14 h-14 mx-auto bg-slate-800/50 rounded-2xl flex items-center justify-center mb-6 border border-slate-700/50" data-id="element-130">
            <Brain className="w-8 h-8 text-cyan-400" data-id="element-131" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-5 leading-tight" data-id="element-132">
            ¿Has sentido que tu cerebro está "hinchado"?
          </h2>
          <div className="space-y-4 text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-133">
            <p data-id="element-134">
              ¿Esa sensación de que, por más café que tomes, tu mente
              simplemente no arranca?
            </p>
            <p data-id="element-135">
              No es falta de motivación. No es que te estés haciendo "viejo".
            </p>
            <p className="text-2xl md:text-3xl font-bold text-white mt-8" data-id="element-136">
              Es{' '}
              <span className="text-cyan-400 text-glow" data-id="element-137">
                Inflamación Celular
              </span>
              .
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}